import { Button, Grid, Typography } from "@mui/material";
import React from "react";
import { Container } from "./styles";

import { CloseIcon } from "../../../assets/icons";
const RemoveItemContainer = ({
  open,
  onClose,
  message,
  children,
}: {
  open: boolean;
  onClose: () => void;
  message: string;
  children: JSX.Element;
}) => {
  return (
    <Container isVisible={open}>
      <Grid style={{ display: "flex", alignItems: "center", gap: "15px" }}>
        <Button
          style={{
            width: "20px",
            height: "20px",
            padding: "0px",
            backgroundColor: "transparent",
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </Button>

        <Typography>{message}</Typography>
      </Grid>
      {children}
    </Container>
  );
};
export default RemoveItemContainer;
